"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterInput = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _baseReactComponents = require("@navinc/base-react-components");

var _filterState = require("../util/filter-state.js");

var _mobileModal = require("../common/mobile-modal");

var _testId = require("../util/test-id");

var _filterIterator = require("../common/filter-iterator");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FilterModal = (0, _styledComponents["default"])(_mobileModal.MobileModal).withConfig({
  displayName: "FilterModal",
  componentId: "sc-2g9f77-0"
})(["&&{@media screen and (", "){display:none;}}"], function (_ref) {
  var forLargerThanPhone = _ref.theme.forLargerThanPhone;
  return forLargerThanPhone;
});
var SelectedIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "SelectedIcon",
  componentId: "sc-2g9f77-1"
})([""]);
var DropdownIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "DropdownIcon",
  componentId: "sc-2g9f77-2"
})([""]);

var DropdownIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DropdownIconWrapper",
  componentId: "sc-2g9f77-3"
})(["@media screen and (", "){transform:rotateZ(90deg);}"], function (_ref2) {
  var forLargerThanPhone = _ref2.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var _Filter = _styledComponents["default"].li.withConfig({
  displayName: "Filter",
  componentId: "sc-2g9f77-4"
})(["&&{padding:0;margin:0;}"]);

var Filters = _styledComponents["default"].ul.withConfig({
  displayName: "Filters",
  componentId: "sc-2g9f77-5"
})(["&&{list-style-type:none;padding:0;margin:0;@media screen and (", "){display:flex;flex-direction:row;align-items:flex-start;justify-content:start;& > ", "{flex:0 0 auto;}}}"], function (_ref3) {
  var forLargerThanPhone = _ref3.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, _Filter);

var FilterTitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "FilterTitle",
  componentId: "sc-2g9f77-6"
})(["&&{text-transform:uppercase;padding:8px 16px;@media screen and (", "){display:none;}}"], function (_ref4) {
  var forLargerThanPhone = _ref4.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var OptionList = _styledComponents["default"].ul.withConfig({
  displayName: "OptionList",
  componentId: "sc-2g9f77-7"
})(["&&{list-style-type:none;padding:0;margin:0;}"]);

var BackButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "BackButtonContainer",
  componentId: "sc-2g9f77-8"
})(["display:flex;flex-direction:row;align-items:center;justify-content:flex-start;padding:8px 16px;margin-bottom:16px;@media screen and (", "){display:none;}& > ", "{flex:0 0 auto;margin-right:8px;}& > ", "{flex:1 0 0;}"], function (_ref5) {
  var forLargerThanPhone = _ref5.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, _baseReactComponents.Icon, _baseReactComponents.Copy); // super hacky invisible select


var NativeSelect = (0, _styledComponents["default"])(_baseReactComponents.Select).withConfig({
  displayName: "NativeSelect",
  componentId: "sc-2g9f77-9"
})(["display:none;opacity:0;@media screen and (", "){display:grid;}"], function (_ref6) {
  var forLargerThanPhone = _ref6.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var FilterContainer = _styledComponents["default"].div.withConfig({
  displayName: "FilterContainer",
  componentId: "sc-2g9f77-10"
})(["position:relative;padding:16px;border-bottom:solid 1px ", ";display:flex;flex-direction:row;align-items:center;justify-content:flex-start;@media screen and (", "){border-bottom:none;}& > ", ",& > ", "{width:16px;height:16px;flex:0 0 16px;margin-left:8px;}& > ", "{@media screen and (", "){display:none;}}& > ", "{flex:1 0 0;@media screen and (", "){white-space:nowrap;}}& > ", "{position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:100%;}"], function (_ref7) {
  var scuttleGray300 = _ref7.theme.scuttleGray300;
  return scuttleGray300;
}, function (_ref8) {
  var forLargerThanPhone = _ref8.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, _baseReactComponents.Icon, DropdownIconWrapper, SelectedIcon, function (_ref9) {
  var forLargerThanPhone = _ref9.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, _baseReactComponents.Copy, function (_ref10) {
  var forLargerThanPhone = _ref10.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, NativeSelect);

var OptionContainer = _styledComponents["default"].div.withConfig({
  displayName: "OptionContainer",
  componentId: "sc-2g9f77-11"
})(["padding:16px;border-bottom:solid 1px ", ";display:flex;flex-direction:row;align-items:center;justify-content:flex-start;& > ", "{flex:0 0 auto;}& > ", "{flex:1 0 0;@media screen and (", "){white-space:nowrap;}}"], function (_ref11) {
  var scuttleGray300 = _ref11.theme.scuttleGray300;
  return scuttleGray300;
}, _baseReactComponents.Icon, _baseReactComponents.Copy, function (_ref12) {
  var forLargerThanPhone = _ref12.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var Option = _styledComponents["default"].li.withConfig({
  displayName: "Option",
  componentId: "sc-2g9f77-12"
})(["padding:0;margin:0;"]);

var FilterInputComponent = function FilterInputComponent(_ref13) {
  var _ref13$filters = _ref13.filters,
      filters = _ref13$filters === void 0 ? [] : _ref13$filters,
      _ref13$multiSelectFil = _ref13.multiSelectFilters,
      multiSelectFilters = _ref13$multiSelectFil === void 0 ? [] : _ref13$multiSelectFil,
      _ref13$activeFilters = _ref13.activeFilters,
      activeFilters = _ref13$activeFilters === void 0 ? {} : _ref13$activeFilters,
      _ref13$filterStepComp = _ref13.filterStepCompletionLabel,
      filterStepCompletionLabel = _ref13$filterStepComp === void 0 ? 'Apply Filters' : _ref13$filterStepComp,
      filterStepCloseLabel = _ref13.filterStepCloseLabel,
      _ref13$filterStepConf = _ref13.filterStepConfirmLabel,
      filterStepConfirmLabel = _ref13$filterStepConf === void 0 ? 'Apply Filters' : _ref13$filterStepConf,
      _ref13$filterStepBack = _ref13.filterStepBackLabel,
      filterStepBackLabel = _ref13$filterStepBack === void 0 ? 'Back' : _ref13$filterStepBack,
      _ref13$onChange = _ref13.onChange,
      _onChange = _ref13$onChange === void 0 ? function () {} : _ref13$onChange,
      _ref13$onComplete = _ref13.onComplete,
      _onComplete = _ref13$onComplete === void 0 ? function () {} : _ref13$onComplete,
      className = _ref13.className,
      theme = _ref13.theme;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      openFilter = _useState2[0],
      setOpenFilter = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Filters, {
    className: className,
    "data-testid": "loanfilter:filters-list",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterIterator.FilterIterator, {
      filters: filters,
      activeFilters: activeFilters,
      multiSelectFilters: multiSelectFilters,
      Filter: function Filter(_ref14) {
        var _activeFilters$name, _, _activeFilters$name2, _activeFilters$name3;

        var name = _ref14.name,
            options = _ref14.options,
            isSingleOption = _ref14.isSingleOption,
            isInUse = _ref14.isInUse,
            multiSelectEnabled = _ref14.multiSelectEnabled;
        var testIdName = (0, _testId.formatForTestId)(name);
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Filter, {
          "data-testid": "loanfilter:filter-".concat(testIdName),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(FilterContainer, {
            onClick: function onClick() {
              return options.length === 0 || options.length === 1 && options[0] === name ? _onChange(isSingleOption && isInUse ? (0, _filterState.removeFilterOptions)(activeFilters, name, [name]) : (0, _filterState.addFilterOptions)(activeFilters, name, [name], multiSelectEnabled)) : setOpenFilter(name);
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
              bold: true,
              "data-testid": "loanfilter:filter-".concat(testIdName, ":label"),
              children: name
            }), isSingleOption && isInUse && /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectedIcon, {
              name: "actions/done",
              color: theme.scuttleGray400,
              height: "16",
              width: "16",
              "data-testid": "loanfilter:filter-".concat(testIdName, ":selected-icon")
            }), !isSingleOption && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownIconWrapper, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DropdownIcon, {
                  name: "actions/carrot-right",
                  color: theme.scuttleGray600,
                  height: "16",
                  width: "16",
                  "data-testid": "loanfilter:filter-".concat(testIdName, ":dropdown-icon")
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(NativeSelect, {
                options: options,
                value: multiSelectEnabled ? (_activeFilters$name = activeFilters[name]) !== null && _activeFilters$name !== void 0 ? _activeFilters$name : [] : (_ = ((_activeFilters$name2 = activeFilters[name]) !== null && _activeFilters$name2 !== void 0 ? _activeFilters$name2 : [])[0]) !== null && _ !== void 0 ? _ : '',
                multiple: multiSelectEnabled,
                onChange: function onChange(e) {
                  return _onChange((0, _filterState.addFilterOptions)(activeFilters, name, [e.target.value]));
                },
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                "data-testid": "loanfilter:filter-".concat(testIdName, ":select")
              })]
            })]
          }), !isSingleOption && /*#__PURE__*/(0, _jsxRuntime.jsxs)(FilterModal, {
            open: openFilter === name,
            onComplete: function onComplete() {
              setOpenFilter(null);

              _onComplete();
            },
            closeLabel: (_activeFilters$name3 = activeFilters[name]) !== null && _activeFilters$name3 !== void 0 && _activeFilters$name3.length ? filterStepConfirmLabel : filterStepCloseLabel,
            completionLabel: filterStepCompletionLabel,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(BackButtonContainer, {
              onClick: function onClick() {
                return setOpenFilter(null);
              },
              "data-testid": "loanfilter:filter-".concat(testIdName, ":back-button"),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
                name: "actions/arrow-back",
                color: theme.scuttleGray500,
                height: "16",
                width: "16"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                size: "md",
                bold: true,
                children: filterStepBackLabel
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterTitle, {
              size: "sm",
              light: true,
              bold: true,
              "data-testid": "loanfilter:filter-".concat(testIdName, ":title"),
              children: name
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OptionList, {
              "data-testid": "loanfilter:filter-".concat(testIdName, ":option-list"),
              children: options.map(function (option) {
                var _activeFilters$name$i, _activeFilters$name4;

                var testIdOption = (0, _testId.formatForTestId)(option);
                var optionActive = (_activeFilters$name$i = (_activeFilters$name4 = activeFilters[name]) === null || _activeFilters$name4 === void 0 ? void 0 : _activeFilters$name4.includes(option)) !== null && _activeFilters$name$i !== void 0 ? _activeFilters$name$i : false;
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(Option, {
                  "data-testid": "loanfilter:filter-".concat(testIdName, ":option-").concat(testIdOption),
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(OptionContainer, {
                    onClick: function onClick() {
                      var _activeFilters$name5;

                      return _onChange(optionActive ? (0, _filterState.removeFilterOptions)(activeFilters, name, [option]) : (0, _filterState.addFilterOptions)(activeFilters, name, multiSelectEnabled ? [].concat((0, _toConsumableArray2["default"])((_activeFilters$name5 = activeFilters[name]) !== null && _activeFilters$name5 !== void 0 ? _activeFilters$name5 : []), [option]) : [option]));
                    },
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
                      bold: true,
                      children: option
                    }), optionActive && /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectedIcon, {
                      name: "actions/done",
                      color: theme.scuttleGray400,
                      height: "16",
                      width: "16",
                      "data-testid": "loanfilter:filter-".concat(testIdName, ":option-").concat(testIdOption, ":selected-icon")
                    })]
                  })
                }, option);
              })
            })]
          })]
        }, name);
      }
    })
  });
};

var FilterInput = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(FilterInputComponent)).withConfig({
  displayName: "FilterInput",
  componentId: "sc-2g9f77-13"
})([""]);
exports.FilterInput = FilterInput;
FilterInput.displayName = 'FilterInput';
//# sourceMappingURL=filter-input.js.map